/* eslint-disable max-len */

import React from 'react'
import { ShimmerBadge,
    ShimmerButton,
    ShimmerTitle,ShimmerThumbnail, ShimmerCircularImage, ShimmerText } from 'react-shimmer-effects'

export default function CartSummarySkeleton() {
    return (
        <div className="lg:w-[30%] w-full lg:mt-0 mt-4 lg:ml-[26px]">
            <div className="border border-[#CBC7C7] p-4 rounded-md ">
                <div className="flex justify-between items-center">
                    <p className="sm:text-lg text-base font-semibold text-[#090406]"><ShimmerBadge width={150}/></p>
                    <p className="text-xs3 font-normal text-[#555259]"><span className="font-semibold"><ShimmerBadge width={150}/></span></p>
                </div>
                <div className="flex justify-between items-center mt-2">
                    <ShimmerBadge width={150}/>
                    <ShimmerBadge width={150}/>
                </div>
                
                <div className="flex justify-between items-center pt-1">
                    <ShimmerBadge width={150}/>
                    <ShimmerBadge width={150}/>

                </div>
                <div className="flex justify-between items-center pt-1">
                    <ShimmerBadge width={150}/>
                    <ShimmerBadge width={150}/>

                </div>
                <div className="mt-6 flex item-center justify-center">
                    <ShimmerButton size="md"/>
                </div>
            </div>
        </div>
    )
}
